// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._268PTvg9wQahr3U8ATVz95{\n  margin: 0 0.5rem;\n}\n  ._268PTvg9wQahr3U8ATVz95 p{\n    font-size: .8rem;\n  }\n", "",{"version":3,"sources":["Footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAIlB;EAHE;IACE,gBAAgB;EAClB","file":"Footer.css","sourcesContent":[".Footer{\n  margin: 0 0.5rem;\n  p{\n    font-size: .8rem;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"Footer": "_268PTvg9wQahr3U8ATVz95"
};
module.exports = exports;
